import useApi from '@/hooks/useApi.ts';
import {ICreateRoleUp, IRole, IRoleFilter, IUpdateRoleUp} from '@/types/role';
import {IPaginatedData, IPaginatorParams, IQueryPaginatorParams} from '@/types/table';
import {TableUtils} from '@/utils/TableUtils.ts';


interface IUseRolesApiHook {
    token?: string
    createRole: (upRole: ICreateRoleUp) => Promise<void>
    getRole: (id: string) => Promise<IRole>
    updateRole: (id: string, data: IUpdateRoleUp) => Promise<void>
    removeRole: (id: string) => Promise<void>
    removeRoles: (ids: string[]) => Promise<void>
    getRoles: (paginator: IPaginatorParams<IRole>, filter?: IRoleFilter) => Promise<IPaginatedData<IRole>>
    getAllRoles: (filter?: IRoleFilter) => Promise<IRole[]>
}

const useRolesApi = (): IUseRolesApiHook => {
    const {token, apiGet, apiPatch, apiPost, apiPut} = useApi();


    const createRole = (upRole: ICreateRoleUp): Promise<void> => {
        return apiPost<ICreateRoleUp, void>('/roles', upRole)
    }

    const getRoles = (paginator: IPaginatorParams<IRole>, filter?: IRoleFilter): Promise<IPaginatedData<IRole>> => {
        const sort = TableUtils.sort2String<IRole>(paginator.sort)
        
        return apiGet<IPaginatedData<IRole>, IRoleFilter & IQueryPaginatorParams>('/roles', { ...paginator, sort, ...filter})
    }


    const getAllRoles = async (filter?: IRoleFilter): Promise<IRole[]> => {
        return apiGet<IRole[], IRoleFilter>('/roles/all', {...filter})
    }

    const getRole = (id: string): Promise<IRole> => {
        return apiGet<IRole>(`/roles/${id}`)
    }

    const updateRole = (id: string, upRole: IUpdateRoleUp): Promise<void> => {
        return apiPut<IUpdateRoleUp, void>(`/roles/${id}`, upRole)
    }

    const removeRole = (id: string): Promise<void> => {
        return apiPatch(`/roles/${id}`, undefined)
    }

    const removeRoles = (ids: string[]): Promise<void> => {
        return apiPatch<{ ids: string[] }, void>('/roles/many', {ids})
    }

    return {
        token,
        createRole,
        removeRole,
        removeRoles,
        updateRole,
        getRole,
        getRoles,
        getAllRoles
    };
};
export default useRolesApi;